import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertController } from '@ionic/angular';

/**
 * Handle CRT Http Error
 */
@Injectable({
  providedIn: 'root',
})
export class CrtHttpErrorHandlerService {
  /**
   * Ouvre seulement une erreur
   * @type {boolean}
   */
  private isErrorOpened = false;

  /**
   * Constructeur
   * @param {AlertController} alertCtrl
   */
  constructor(private alertCtrl: AlertController) {}

  /**
   * Ouvre une alerte en cas d'erreur HTTP
   * @param {HttpErrorResponse} e
   * @returns {Promise<void>}
   */
  async handleError(e: HttpErrorResponse) {
    if (!this.isErrorOpened) {
      const alert = await this.alertCtrl.create({
        header: $localize`Erreur`,
        subHeader: $localize`Impossible de mettre à jour les données`,
      });
      this.isErrorOpened = true;
      await alert.present();

      console.error(e);

      await alert.onDidDismiss();
      this.isErrorOpened = false;
    }
  }
}
